import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

import he from "he";

import Formatter from "/src/lib/formatter";

const style = {
  overlayContainer: {
    position: 'absolute',
    inset: 0
  },
  overlayBackground: {
    zIndex: 1,
    position: 'absolute',
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  overlayBadges: {
    zIndex: 2,
    position: 'relative',
    color: 'white'
  },
  overlayText: {
    zIndex: 2,
    position: 'absolute',
    color: 'white',
    inset: 0
  }
}

function Component({ data, ...otherProps }) {

  // Move custom fields to HOOK

  // const listing_source = data.listing_source?.[0] || "";
  // const listing_source_class = `listing_source_${listing_source.toLowerCase()}`;

  const renderImageOverlay = () => {

    // listing_source = New or Resale etc (Keep this)
    // availability
    // feature

    let ribbon = [];
    if (data.availability.includes(10)) {
      ribbon.push(
        <div key="availability">
          <div style={style.overlayBackground} className="ribbon-overlay"></div>
          <div style={style.overlayText} className="h-100 d-flex flex-column align-items-center justify-content-center">
            <div className="bg-danger p-2">SOLD</div>
          </div>
        </div>
      );
    }
    if (ribbon.length > 0) {
      return (
        <div style={style.overlayContainer}>
          {ribbon}
        </div>
      );
    }
  }

  const renderPrice = () => {
    if (data.price > 0) {
      return (
        <div className="d-flex flex-row gap-1">
          <div className="fw-bold">{Formatter.money(data.price, 0, '$')}</div>
          <Badge bg="light" className="rounded-0 border-0 text-dark fw-normal">
            {data.price_type}
          </Badge>
        </div>
      );
    }
  }

  const renderSize = () => {
    let info = [];
    if (data.floor_area > 0) {
      info.push(
        <div key="floor_area">{Formatter.money(data.floor_area)} {data.floor_area_type}</div>
      );
    }
    if (data.land_area > 0) {
      info.push(
        <div key="land_area">{Formatter.money(data.land_area)} {data.land_area_type} (Land)</div>
      );
    }
    if (info.length > 0) {
      return (
        <div className="d-flex flex-row gap-1">
          {info}
        </div>
      );
    }
  }

  const renderBedBath = () => {
    let info = [];
    if (data.bedrooms > 0) {
      info.push(
        <div key="bedrooms">{data.bedrooms} Beds</div>
      );
    }
    if (data.bathrooms > 0) {
      info.push(
        <div key="bathrooms">{data.bathrooms} Baths</div>
      );
    }
    if (info.length > 0) {
      return (
        <div className="d-flex flex-row gap-1">
          {info}
        </div>
      );
    }
  }

  const renderBadges = () => {
    let badge = [];
    if (data.property_type) {
      badge.push(
        <Badge key="property_type" bg="light" className="rounded-0 border-0 text-dark fw-normal">
          {data.property_type}
        </Badge>
      );
    }
    if (data.location) {
      badge.push(
        <Badge key="location" bg="light" className="rounded-0 border-0 text-dark fw-normal">
          {data.location}
        </Badge>
      );
    }
    if (data.tenure) {
      badge.push(
        <Badge key="tenure" bg="light" className="rounded-0 border-0 text-dark fw-normal">
          {data.tenure}
        </Badge>
      );
    }
    if (badge.length > 0) {
      return (
        <div className="d-flex flex-row flex-wrap align-items-start gap-1" style={{ marginLeft: "-.5em" }}>
          {badge}
        </div>
      );
    }
  }

  const renderListingType = () => {
    // const DICTIONARY = {
    //   "For Sale": "Sold",
    //   "For Rent": "Leased",
    // }
    // let listing_type = data.listing_type;
    // if (listing_source === "Transaction") {
    //   listing_type = DICTIONARY[data.listing_type];
    // }
    return (
      <div className={`tiny`}>{data.listing_type}</div>
    );
  }

  const renderImage = () => {
    if (data.featured_media_url__medium_large) {
      return (
        <Card.Img variant="top" loading="lazy" src={data.featured_media_url__medium_large} />
      );
    }
  }

  //xl={3} lg={4} md={4} sm={6} xs={6}
  otherProps.className = (otherProps.className || "") + ``;
  return (
    <Card {...otherProps}>
      <div className="position-relative">
        {renderImageOverlay()}
        {renderImage()}
      </div>
      <Card.Body className="d-flex flex-column gap-1">
        <div className="listing_type">{renderListingType()}</div>
        <div className="listing_title fw-bold">{he.decode(data.title?.rendered)}</div>
        <div className="listing_price">{renderPrice()}</div>
        <div className="small d-flex flex-column gap-1">
          <div className="listing_size">{renderSize()}</div>
          <div className="listing_bed_bath">{renderBedBath()}</div>
        </div>
        <div className="listing_badges">{renderBadges()}</div>
      </Card.Body>
    </Card>
  );

}

export default Component;
